export const PLATFORM_ID = 149
export const DEFAULT_CATEGORY = 'ui'
export const DEFAULT_LOCALE = 'en'
export const DEFAULT_BRAND_ID = 1
